import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ChatButtonProps } from './chats-list-item.interface';

export function ChatListItemComponent({
  chat,
  selected,
  onClick,
  onDelete,
}: ChatButtonProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        borderRadius: '10px',
        border: 1,
        borderColor: selected ? 'primary.main' : 'divider',
        bgcolor: selected ? 'action.selected' : 'background.paper',
        transition: 'background-color 0.2s ease, border-color 0.2s ease',
        '&:hover': {
          bgcolor: selected ? 'action.selected' : 'action.hover',
          borderColor: selected ? 'primary.main' : 'text.secondary',
        },
      }}
    >
      <Box
        component="button"
        type="button"
        onClick={onClick}
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          border: 0,
          background: 'none',
          cursor: 'pointer',
          px: 1.5,
          py: 1.25,
          color: 'inherit',
          font: 'inherit',
          textAlign: 'left',
        }}
      >
        <Typography
          variant="body1"
          sx={{
            textAlign: 'left',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {chat.name}
        </Typography>
      </Box>
      {onDelete ? (
        <IconButton
          size="small"
          aria-label={t('chats.delete')}
          onClick={(event) => {
            event.stopPropagation();
            onDelete();
          }}
          sx={{ mr: 0.5, flexShrink: 0 }}
        >
          <DeleteOutlinedIcon fontSize="small" />
        </IconButton>
      ) : null}
    </Box>
  );
}
